import ExternalContainer from '@/containers/ExternalContainer'
import ExternalCreateTicketView from '@/views/ExternalCreateTicket'
import ExternalTicketListView from '@/views/ExternalTicketList'
import ExternalNotFoundView from '@/views/ExternalNotFound'
import ExternalTaskDetailView from '@/views/ExternalTaskDetail'
import ExternalTaskUpdatedView from '@/views/ExternalTaskUpdated'
import ExternalTicketCreatedView from '@/views/ExternalTicketCreated'
import ExternalUnauthorizedView from '@/views/ExternalUnauthorized'
import ExternalTicketDetailView from '@/views/ExternalTicketDetail'
import ExternalBlockedView from '@/views/ExternalBlocked'
import ExternalRequestAccessView from '@/views/ExternalRequestAccess'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ExternalContainer',
    redirect: '/notFound',
    component: ExternalContainer,
    meta: { title: 'Atendimento' },
    children: [
      {
        path: '/createTicket',
        name: 'ExternalCreateTicket',
        component: ExternalCreateTicketView
      },
      {
        path: '/taskDetail',
        name: 'ExternalTaskDetail',
        component: ExternalTaskDetailView
      },
      {
        path: '/ticketList',
        name: 'ExternalTicketList',
        component: ExternalTicketListView
      },
      {
        path: '/ticketCreated',
        name: 'ExternalTicketCreated',
        component: ExternalTicketCreatedView
      },
      {
        path: '/taskUpdated',
        name: 'ExternalTaskUpdated',
        component: ExternalTaskUpdatedView
      },
      {
        path: '/notFound',
        name: 'ExternalNotFound',
        component: ExternalNotFoundView
      },
      {
        path: '/unauthorized',
        name: 'ExternalUnauthorized',
        component: ExternalUnauthorizedView
      },
      {
        path: '/ticketDetail',
        name: 'ExternalTicketDetail',
        component: ExternalTicketDetailView
      },
      {
        path: '/blocked',
        name: 'ExternalBlocked',
        component: ExternalBlockedView
      },
      {
        path: '/requestAccess',
        name: 'ExternalRequestAccess',
        component: ExternalRequestAccessView
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to, from) => {
  changeDocumentTitle(to)
})

const changeDocumentTitle = (routeSnapshot) => {
  const routeTitle = getRouteTitle(routeSnapshot.matched)
  if (routeTitle) {
    document.title = routeTitle
    return
  }
  document.title = 'Customer Service'
}

const getRouteTitle = (matchedRoutes) => {
  const routeWithTitle = Array.from(matchedRoutes).reverse().find(route => route.meta.title)
  return routeWithTitle ? routeWithTitle.meta.title : null
}

export default router
